import React, { useEffect, useState } from 'react';
import { auth, db } from '../FirebaseComp/firebase'; // Ensure correct path
import { doc, getDoc } from 'firebase/firestore';

import './userprofile.css';

function UserProfile() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      const currentUser = auth.currentUser;
      if (currentUser) {
        try {
          const userRef = doc(db, 'users', currentUser.uid);
          const docSnap = await getDoc(userRef);
          if (docSnap.exists()) {
            setUser(docSnap.data());
          } else {
            console.log("No such document!");
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      }
    };
    fetchUserData();
  }, []);

  return (
    <>
<section className="apc-hero-section">
  <div className="apc-hero-image-wrapper">
    <img src="/logo192.png" alt="Asian Polytechnic Campus" className="apc-hero-image" />
  </div>
  <div className="apc-hero-content">
    <h1 className="apc-hero-title">Asian Polytechnic Campus</h1>
    <p className="apc-hero-text">
      Welcome to the Asian Polytechnic Campus, where innovation meets excellence. 
      Our dynamic learning environment offers personalized courses, cutting-edge resources, 
      and interactive tools that empower you to achieve your fullest potential. 
      We are committed to fostering academic brilliance, practical skills, and a passion 
      for lifelong learning, preparing you to excel in today’s fast-evolving world.
    </p>
  </div>
</section>

    <div className="user-profile-container">
    <img src="/user.jpg" alt="User Profile" />
      <h2 className="user-profile-header">My Profile</h2>
      {user ? (
        <>
          <div className="user-info">
            <p className="user-info-item"><strong>Name:</strong> {user.name}</p>
            <p className="user-info-item"><strong>Email:</strong> {user.email}</p>
            <p className="user-info-item"><strong>Contact No:</strong> {user.contactNo}</p>
            {/* <p className="user-info-item"><strong>Country:</strong> {user.country}</p> */}

          </div>
        </>
      ) : (
        <p>Hello,...</p>
      )}
    </div>
    </>
  );
}

export default UserProfile;
